import { WatchedAlertRuleSchema } from '../base.js';
export const CreateWatchedAlertBodySchema = WatchedAlertRuleSchema.omit({ id: true });
export const CreateWatchedAlertRequestSchema = CreateWatchedAlertBodySchema;
export const CreateWatchedAlertResponseSchema = WatchedAlertRuleSchema.pick({ id: true });
